import { tarjetaDeRuta } from './registro';

/**
 * La ruta de destino de una notificación, validada otra vez en el Front (el servidor ya la validó al guardar y al servir, pero aquí no se confía en nadie).
 * Devuelve la ruta lista para el router de Angular, o null si no pasa. Pasa solo si:
 *  - es un texto que empieza con UNA sola «/» (ruta relativa del portal: nada de `//dominio`, `https://…`, `javascript:…`, `\\`, ni espacios o caracteres de control);
 *  - usa solo caracteres de una dirección normal (letras, números, `- . _ ~ % /` y, tras un «?», `= & , /`): sin `{obra}` sin resolver, `<`, comillas ni `#`;
 *  - decodificada no esconde `//`, `\`, `..` ni un `:` en el primer tramo; y
 *  - pertenece a una pantalla del registro único de navegación (`tarjetaDeRuta`): una dirección que el portal no conoce no se abre.
 * Una notificación cuya ruta no pasa se muestra igual, pero no navega.
 */
const LARGO_MAXIMO = 300;
const FORMA = /^\/[A-Za-z0-9\-._~%/]*(\?[A-Za-z0-9\-._~%=&,/]*)?$/;

export function rutaDestinoSegura(ruta: unknown): string | null {
  if (typeof ruta !== 'string') return null;
  const r = ruta.trim();
  if (!r || r.length > LARGO_MAXIMO || r !== ruta) return null;
  if (!r.startsWith('/') || r.startsWith('//')) return null;
  if (!FORMA.test(r)) return null;

  const [camino] = r.split('?', 1);
  let decodificado: string;
  try {
    decodificado = decodeURIComponent(camino);
  } catch {
    return null;
  }
  if (decodificado.includes('//') || decodificado.includes('\\') || /(^|\/)\.\.?(\/|$)/.test(decodificado)) return null;
  if (/^\/[^/]*:/.test(decodificado)) return null;

  return tarjetaDeRuta(r) ? r : null;
}
